// extracted by mini-css-extract-plugin
export default {"appContainer":"Home_appContainer__s-s6o"};